export const REPORT_TYPE = {
	ADMIN_CUSTOMER_REPORT: 'admin_customer_report',
	SENIOR_CONSOLIDATE_REPORT: 'senior_consolidate_report',
	ROUTE_INFO_REPORT: 'route_info_report'
}